export default __webpack_public_path__ + "static/media/analytics_recovered.0bd52d14.svg";